var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChannel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6484 0.5H2.85156C2.19531 0.5 1.63021 0.736979 1.15625 1.21094C0.71875 1.64844 0.5 2.19531 0.5 2.85156V19.1484C0.5 19.8047 0.71875 20.3698 1.15625 20.8438C1.63021 21.2812 2.19531 21.5 2.85156 21.5H19.1484C19.8047 21.5 20.3516 21.2812 20.7891 20.8438C21.263 20.3698 21.5 19.8047 21.5 19.1484V6.35156L15.6484 0.5ZM5.14844 5.14844H11V7.5H5.14844V5.14844ZM16.8516 16.8516H5.14844V14.5H16.8516V16.8516ZM16.8516 12.1484H5.14844V9.85156H16.8516V12.1484ZM14.5 7.5V2.85156L19.1484 7.5H14.5Z",
    fill: "#7C7C7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChannel);
export default __webpack_public_path__ + "static/media/ic_channel.086991ebde2b1a89d600ebc268369cf9.svg";
export { ForwardRef as ReactComponent };